import { render, staticRenderFns } from "./ScreenControl.vue?vue&type=template&id=3bc09152&"
import script from "./ScreenControl.vue?vue&type=script&lang=js&"
export * from "./ScreenControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports